import { ELISA_ICCID_PREFIX } from './validationUtils.js';
import { SimType, ValidateSimFreeResponse } from '../../generated/api/models.js';
import { dataNotAvailableMsg, invalidSIMCardNumberMsg, simCardAlreadyInUseMsg, simCardMsg, t } from '../i18n/index.js';
import type { Address, Subscription } from '../../generated/api/models.js';
import type { AuthenticatedUser } from '../../public/site/authState';

export const getSimTypeAsString = (simType?: SimType): string => {
  switch (simType) {
    case SimType.PHYSICAL_MINI_MICRO:
      return 'Mini + Micro';

    case SimType.PHYSICAL_NANO:
      return 'Nano';

    case SimType.PHYSICAL:
      return t.PIZC(simCardMsg);

    case SimType.ESIM:
      return 'eSIM';

    default:
      return t.PJC3(dataNotAvailableMsg);
  }
};

// Copied from https://github.com/EDumdum/luhn/blob/master/src/luhn.js (MIT license)
export function getLuhnRemainder(value: string) {
  value = ELISA_ICCID_PREFIX + value;
  const CHARCODE_0 = '0'.charCodeAt(0);
  const MAPPING_EVEN = [0, 2, 4, 6, 8, 1, 3, 5, 7, 9];
  let length = value.length;
  let accumulator = 0;
  let bit = 0;

  while (length-- > 0) {
    // eslint-disable-next-line
    accumulator += (bit ^= 1)
      ? value.charCodeAt(length) - CHARCODE_0
      : MAPPING_EVEN[value.charCodeAt(length) - CHARCODE_0];
  }

  return accumulator % 10;
}

export const localizeValidationErrorMessage = (errorType: string) => {
  switch (errorType) {
    case ValidateSimFreeResponse.ErrorTypeEnum.ALREADY_IN_USE: {
      return t.ZNS1(simCardAlreadyInUseMsg);
    }
    case ValidateSimFreeResponse.ErrorTypeEnum.INVALID_NUMBER: {
      return t.SDXB(invalidSIMCardNumberMsg);
    }
    default:
      // This should never happen but if it does, there is probably some another error somewhere
      return undefined;
  }
};

export const getChangeSimServiceFeePayload = (
  simType?: SimType,
  subscription?: Subscription,
  address?: Address,
  user?: AuthenticatedUser | null
) => ({
  simType,
  iccId: subscription?.details?.mobile?.simCardNumber,
  deliveryAddress: {
    ...{ address: address || ({} as Address) },
    recipient: user?.userName || '',
    phoneNumber: user?.mobile || '',
    companyName: user?.companyName || '',
  },
});
